<template>
<transition name="modal" appear>
    <div class="modal modal-overlay">
        <div class="modal-dialog modal-dialog-centered w-300px" role="document">
            <div class="modal-content">
                <a type="button" class="close" @click="$emit('close')" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">
                        <img src="../../../assets/img/close.png" alt="close" class="pointer close-btn" @click="closeModal()">
                    </span>
                </a>
                <div class="modal-body">
                    <div>
                        <h3 class="font-14 bold mb-20">프로그램을 선택해 주세요</h3>
                        <div v-for="(item, index) of programList" :key="index" class="mt-05 mb-10">
                            <p class="txt-blue pointer" @click="applyProgram(item.idx)">{{item.program_name}}</p>
                        </div>
                    </div>
                </div>
                <!-- <div class="modal-footer txt-center">
                    <a class="admin-btn-default btn pointer" @click="exportData()" data-dismiss="modal" aria-label="Close">입력 완료</a>
                </div> -->
            </div>
        </div>
    </div>
</transition>
</template>

<script>
export default {
    props: ['parentIdx'],
    data: () => ({
        programList: []
    }),
    mounted() {
        console.log('this.parentIdx', this.parentIdx)
        var pageIdx = this.parentIdx

        var params = {
            pageIdx: pageIdx
        }
        this.axios.get(this.axios.root + this.axios.port + `/admin/program-info/${pageIdx}`, params)
            .then(res => {
                console.log('res', res)
                if (res.data.err === 0) {
                    this.programList = res.data.programList
                    if (this.programList.length === 0) {
                        alert('프로그램이 없습니다.')
                        this.$emit('close')
                    }
                }
            })
    },

    beforeDestroy() {},

    methods: {
        // 선택한 프로그램 수강신청으로 보내기
        closeModal() {
            this.$emit('close')
        },

        applyProgram (idx) {
            this.$emit('applyProgram', idx)
        },

        exportData() {
            var options = []
            for (var item of this.options) {
                if (item.content.trim() !== '') {
                    options.push(item.content)
                }
            }

            options = options.join('^')
            this.$emit('save', options, this.modalIndex)
        },

        addOptions() {
            if (this.options.length === 10) {
                alert('옵션은 최대 10개 까지만 추가 가능합니다.')
                return false
            }
            this.options.push({
                content: ''
            })
        },

        delOptions() {
            var length = this.options.length
            this.options.splice(length - 1, 1)
        }
    }
}
</script>

<style lang="scss" scoped>
.modal {
    &.modal-overlay {
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        z-index: 30;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
    }

    &-window {
        border-radius: 4px;
        overflow: hidden;
    }

    &-content {
        padding: 10px 20px;
    }
}

.modal-enter-active,
.modal-leave-active {
    transition: opacity 0.4s;

    .modal-window {
        transition: opacity 0.4s, transform 0.4s;
    }
}

.modal-leave-active {
    transition: opacity 0.6s ease 0.4s;
}

.modal-enter,
.modal-leave-to {
    opacity: 0;

    .modal-window {
        opacity: 0;
        transform: translateY(-20px);
    }
}
</style>
